module.exports = __webpack_public_path__ + "img/customer-contract.bb032e99.jpg";